<template>
    <div>
        <vue-headful :title="'Set Current Jobsite :: MeritEHS'"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link to="/profile">
                        <i class="fa fa-user"></i> Profile
                    </router-link>
                </li>
                <li class="breadcrumb-item active">Set Current Jobsite</li>
            </ol>
        </h4>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="alert alert-success">
                        <strong>Set Current Jobsite:</strong>
                        <p>This will set your current Jobsite. When creating observations/incidents/inspections, EHS will default the Jobsite to one selected below.</p>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div v-bind:class="{ 'form-group': true, 'has-error': errors.JobsiteId }" class="row">
                                <label :class="{ 'col-lg-3 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.JobsiteId }">Jobsite: <i class="fa fa-asterisk text-danger small"></i></label>
                                <div class="col-sm-8">

                                    <jobsite-select :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate"></jobsite-select>

                                    <span v-if="errors.JobsiteId" class="text-danger">
                                        <span v-for="error in errors.JobsiteId">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="updateJobsite()" :disabled="saving">
                Set Current Jobsite
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                jobsite: null,
                errors: {},
            }
        },

        computed: {
            JobsiteValues(){
                if(!this.jobsite || this.jobsite == null)
                {
                    return null;
                }

                //Send it
                return this.jobsite;
            }
        },

        methods: {
            onJobSiteSelectUpdate(jobsite){
                //Set the ID
                this.jobsite = jobsite;
            },

            getJobsite(){
                //Send it
                this.$http.get('profile/jobsite')
                    .then(res => {
                        //Set it
                        this.jobsite = res.data.jobsite;
                    })
                    .then(() => {
                        //Set flag
                        this.loading = false;
                    });
            },

            updateJobsite: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('profile/jobsite', {jobsite_id: this.jobsite ? this.jobsite.JobsiteId : null})
                .then(response => {
                    //Commit the Jobsite to the Store
                    this.$store.commit('currentJobsite', this.jobsite);

                    //Alert the user?
                    this.$toastr.success('Jobsite Set');

                    //Return to main list?
                    this.$router.push('/');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data;
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted(){
            //Get the users jobsite
            this.getJobsite();
        }
    }
</script>
